import { LangConstant, SystemConstant } from "const";
import { getCommonLang, getNSLang } from "utils/lang.utils";

export const GALLERY_TABS = {
  all: {
    index: 0,
    label: getCommonLang("TXT_ALL"),
  },
  sent: {
    index: 1,
    label: getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_SENT"),
  },
  shareByOther: {
    index: 2,
    label: getNSLang(LangConstant.NS_HOME, "TXT_SHARE_BY_OTHER"),
  },
};

export const GALLERY_TAB_ARRAY = [
  { label: GALLERY_TABS.all.label },
  { label: GALLERY_TABS.sent.label },
  { label: GALLERY_TABS.shareByOther.label },
];

export const FILTER_FILE_TYPE = {
  pdf: SystemConstant.FILE_TYPE.PDF,
  image: SystemConstant.FILE_TYPE.IMAGE,
  video: SystemConstant.FILE_TYPE.VIDEO,
  audio: SystemConstant.FILE_TYPE.AUDIO,
  otherFile: SystemConstant.FILE_TYPE.OTHER,
  link: SystemConstant.FILE_TYPE.LINK,
};

export const FILE_FILTER_OPTIONS = [
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_PDF"),
    value: FILTER_FILE_TYPE.pdf,
  },
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_IMAGE"),
    value: FILTER_FILE_TYPE.image,
  },
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_VIDEO"),
    value: FILTER_FILE_TYPE.video,
  },
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_AUDIO"),
    value: FILTER_FILE_TYPE.audio,
  },
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_OTHER_FILE"),
    value: FILTER_FILE_TYPE.otherFile,
  },
  {
    label: getNSLang(LangConstant.NS_MANAGE_FILE, "TXT_LINK"),
    value: FILTER_FILE_TYPE.link,
  },
];
